module.exports = __webpack_public_path__ + "8248edd93f6a6577a378ad7adb81f92b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/walk/apple-touch-icon.png
// module id = 1852
// module chunks = 1